import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../Firebase/config";
const uploadImage = async (file) => {
  if (!file) {
    throw new Error("No file provided");
  }

  const storageRef = ref(storage, `images/$ {file.name}`);
  await uploadBytes(storageRef, file);
  const url = await getDownloadURL(storageRef);
  return url;
};

export { uploadImage };
